module.exports = __webpack_public_path__ + "img/xlsx.b07b0d49.svg";